import { backoff, promisify } from "../utils/promises";
export default {
    getChars: backoff(promisify(() => window.opr.operaBrowserPrivate.getChars)),
    getEdition: promisify(() => window.opr.operaBrowserPrivate.getEdition),
    getUtmCampaign: promisify(() => window.opr.operaBrowserPrivate.getUtmCampaign),
    getProduct: promisify(() => window.opr.operaBrowserPrivate.getProduct),
    getVersion: promisify(() => window.opr.operaBrowserPrivate.getVersion),
};
